import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Group } from '../components/Group';
import { isAddressGroup, isAddressIEEE } from '../types/Zigbee/Address';
import { clusterNameAndHex } from '../types/Zigbee/Cluster';
const ZigbeeNodeBindingTableTable = (props) => {
    const bindingtable = [];
    let index = 0;
    for (const bt of props.items) {
        if (isAddressGroup(bt.destination)) {
            bindingtable.push(_jsxs("tr", { children: [_jsx("td", { children: bt.source.ieee }), _jsx("td", { children: bt.source.endpoint }), _jsx("td", { children: clusterNameAndHex(bt.source.cluster) }), _jsx("td", { children: bt.destination.group }), _jsx("td", {}), _jsx("td", {}), _jsx("td", { children: _jsx("button", { onClick: () => props.onUnbind(bt), children: "Delete" }) })] }, index++));
        }
        else if (isAddressIEEE(bt.destination)) {
            bindingtable.push(_jsxs("tr", { children: [_jsx("td", { children: bt.source.ieee }), _jsx("td", { children: bt.source.endpoint }), _jsx("td", { children: clusterNameAndHex(bt.source.cluster) }), _jsx("td", {}), _jsx("td", { children: bt.destination.ieee }), _jsx("td", { children: bt.destination.endpoint }), _jsx("td", { children: _jsx("button", { onClick: () => props.onUnbind(bt), children: "Delete" }) })] }, index++));
        }
        else {
            console.error('Unknown binding table destination adress type');
        }
    }
    return (_jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: { textAlign: 'left' }, children: "Source addr" }), _jsx("th", { style: { textAlign: 'left' }, children: "Source endpoint" }), _jsx("th", { style: { textAlign: 'left' }, children: "Source cluster" }), _jsx("th", { style: { textAlign: 'left' }, children: "Dest group" }), _jsx("th", { style: { textAlign: 'left' }, children: "Dest addr" }), _jsx("th", { style: { textAlign: 'left' }, children: "Dest endpoint" }), _jsx("th", { style: { textAlign: 'left' }, children: "Operation" })] }) }), _jsx("tbody", { children: bindingtable })] }));
};
export const ZigbeeNodeBindingTable = (props) => {
    var _a, _b, _c;
    const ts = (_a = props.bindingtable) === null || _a === void 0 ? void 0 : _a.fetched_ts;
    const last_fetched = ts == undefined ? '?' : (new Date(ts).toLocaleString());
    const title = 'Binding table (' + last_fetched + ')';
    const [srcIEEE, setSrcIEEE] = useState('');
    const [srcEP, setSrcEP] = useState('');
    const [srcCluster, setSrcCluster] = useState('');
    const [dstGroup, setDstGroup] = useState('');
    const [dstIEEE, setDstIEEE] = useState('');
    const [dstEP, setDstEP] = useState('');
    function submit() {
        let ieee = srcIEEE;
        if (ieee == '' && props.ieee != null) {
            ieee = props.ieee;
        }
        if (ieee == '') {
            console.log('Missing source IEEE value');
            return;
        }
        if (srcEP == '') {
            console.log('Missing source EP value');
            return;
        }
        if (srcCluster == '') {
            console.log('Missing source cluster value');
            return;
        }
        let destination;
        if (dstGroup != '') {
            destination = {
                group: parseInt(dstGroup)
            };
        }
        else if (dstIEEE != '' && dstEP != '') {
            destination = {
                ieee: dstIEEE,
                endpoint: parseInt(dstEP)
            };
        }
        else {
            console.log('Missing destination');
            return;
        }
        const btItem = {
            source: {
                ieee,
                endpoint: parseInt(srcEP),
                cluster: parseInt(srcCluster)
            },
            destination
        };
        props.onBind(btItem);
        setSrcIEEE('');
        setSrcEP('');
        setSrcCluster('');
        setDstGroup('');
        setDstIEEE('');
        setDstEP('');
    }
    return (_jsxs(Group, { title: title, children: [_jsx(ZigbeeNodeBindingTableTable, { items: (_c = (_b = props.bindingtable) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [], onUnbind: props.onUnbind }), _jsx("form", { onSubmit: props.onFetchBindingTable, style: { padding: '10px 10px' }, children: _jsx("button", { type: "submit", children: "Fetch" }) }), _jsxs(_Fragment, { children: [_jsx("input", { type: "text", size: 16, placeholder: "Src IEEE", value: srcIEEE, onChange: e => setSrcIEEE(e.target.value) }), _jsx("input", { type: "text", size: 6, placeholder: "Src Endpoint", value: srcEP, onChange: e => setSrcEP(e.target.value) }), _jsx("input", { type: "text", size: 6, placeholder: "Src Cluster", value: srcCluster, onChange: e => setSrcCluster(e.target.value) }), _jsx("input", { type: "text", size: 6, placeholder: "Dst Group", value: dstGroup, onChange: e => setDstGroup(e.target.value) }), _jsx("input", { type: "text", size: 16, placeholder: "Dst IEEE", value: dstIEEE, onChange: e => setDstIEEE(e.target.value) }), _jsx("input", { type: "text", size: 6, placeholder: "Dst Endpoint", value: dstEP, onChange: e => setDstEP(e.target.value) }), _jsx("button", { onClick: submit, children: "Bind" })] })] }));
};
